<template>
    <!-- 底部组件 -->
    <footer class="gp-footer">
        <!-------------中文------->
        <div v-if="this.$store.state.language == 'zh'" class="footer footer--mobile no-select mobile">
            <div class="footer__inner">
                <div class="site__footer--logo"></div>
                <div class="footer__social-mobile">
                    <!-- facebook -->
                    <a href="https://www.facebook.com/profile.php?id=100011243130897" target="_blank" v-show="false">
                        <div class="footer__icon-mobile footer__icon-mobile--facebook"></div>
                    </a>
                    <!-- twitter -->
                    <a href="https://twitter.com/gamepochsh" target="_blank" v-show="false">
                        <div class="footer__icon-mobile footer__icon-mobile--twitter"></div>
                    </a>
                    <!-- wechat -->
                    <a class="gp-qrcode-wrap" target="_blank" v-show="false">
                        <div class="footer__icon-mobile footer__icon-mobile--youtube"></div>
                    </a>
                    <!-- weibo -->
                    <a href="https://weibo.com/gamepoch" target="_blank">
                        <div class="footer__icon-mobile footer__icon-mobile--twitch"></div>
                    </a>
                    <!-- instagram -->
                    <a href="https://www.instagram.com/gamepoch_cn/" target="_blank" v-show="false">
                        <div class="footer__icon-mobile footer__icon-mobile--instagram"></div>
                    </a>
                    <br>
                    <img src="../assets/wxQrCode.jpg" class="gp-qrcode-mobile" alt="">
                    <br>
                    <br>
                    <span>扫码关注微信</span>
                </div>
                <div class="footer__cell--left-text">
                    星游纪版权所有 | 家长监护
                    <br>
                    为了您的健康，请合理安排游戏时间。
                    <br>
                    上海星游纪信息技术有限公司
                    <br>
                    沪ICP证 沪B2-20160111 | 沪网文（2016）0033-033号 | <a class="footer-Records-Link" href="https://beian.miit.gov.cn/" >沪ICP备15039130号</a>
                    <br>
                    沪公网安备 31010702004061号
                    <br>
                    出版物经营许可证号：新出发沪批字第Y7061号
                </div>
                <div class="footer__copyright">
                    © {{this.year}} Gamepoch Inc. All rights reserved.
                </div>
            </div>
        </div>

        <div v-if="this.$store.state.language == 'zh'" class="footer footer--desktop no-select desktop">
            <div class="footer__inner">
                <div class="footer__cell footer__cell--left">
                    <div class="footer__cell--left-text">
                        星游纪版权所有 | 家长监护
                        <br>
                        为了您的健康，请合理安排游戏时间。
                        <br>
                        上海星游纪信息技术有限公司
                        <br>
                        沪ICP证 沪B2-20160111 | 沪网文（2016）0033-033号 | <a class="footer-Records-Link" href="https://beian.miit.gov.cn/" >沪ICP备15039130号</a>
                        <br>
                        沪公网安备 31010702004061号
                        <br>
                        出版物经营许可证号：新出发沪批字第Y7061号
                    </div>
                </div>
                <a href="" class="site__footer--logo"></a>
                <div class="footer__cell footer__cell--right">
                    <div class="footer__social-desktop">
                        <span>
                        <span class="footer__connect">CONNECT</span>
                        </span>
                        <span class="footer__spacer">|</span>
                        <!-- facebook -->
                        <a href="https://www.facebook.com/profile.php?id=100011243130897" target="_blank" v-show="false">
                        <div class="footer__icon footer__icon--facebook"></div>
                        </a>
                        <!-- twitter -->
                        <a href="https://twitter.com/gamepochsh" target="_blank" v-show="false">
                        <div class="footer__icon footer__icon--twitter"></div>
                        </a>
                        <!-- wechat -->
                        <a target="_blank" class="gp-qrcode-wrap">
                        <div class="footer__icon footer__icon--youtube"></div>
                        </a>
                        <!-- weibo -->
                        <a href="https://weibo.com/gamepoch" target="_blank">
                        <div class="footer__icon footer__icon--twitch"></div>
                        </a>
                        <!-- ins -->
                        <a href="https://www.instagram.com/gamepoch_cn/" target="_blank" v-show="false">
                        <div class="footer__icon footer__icon--instagram"></div>
                        </a>
                    </div>
                    <div class="footer__copyright">
                        © {{this.year}} Gamepoch Inc. All rights reserved.
                    </div>
                </div>
        </div>
        </div>
        <!-- ------------------ -->

        <!-------------english------->
        <div v-if="this.$store.state.language == 'en'" class="footer footer--mobile no-select mobile">
            <div class="footer__inner">
                <div class="site__footer--logo"></div>
                <div class="footer__social-mobile">
                    <!-- facebook -->
                    <a href="https://www.facebook.com/profile.php?id=100011243130897" target="_blank" v-show="true">
                        <div class="footer__icon-mobile footer__icon-mobile--facebook"></div>
                    </a>
                    <!-- twitter -->
                    <a href="https://twitter.com/gamepochsh" target="_blank" v-show="true">
                        <div class="footer__icon-mobile footer__icon-mobile--twitter"></div>
                    </a>
                    <!-- wechat -->
                    <a class="gp-qrcode-wrap" target="_blank" v-show="true">
                        <div class="footer__icon-mobile footer__icon-mobile--youtube"></div>
                    </a>
                    <!-- weibo -->
                    <a href="https://weibo.com/gamepoch" target="_blank">
                        <div class="footer__icon-mobile footer__icon-mobile--twitch"></div>
                    </a>
                    <!-- instagram -->
                    <a href="https://www.instagram.com/gamepoch_cn/" target="_blank" v-show="true">
                        <div class="footer__icon-mobile footer__icon-mobile--instagram"></div>
                    </a>
                    <br>
                    <img src="../assets/wxQrCode.jpg" class="gp-qrcode-mobile" alt="">
                    <br>
                    <br>
                    <span>Scan QR code</span>
                </div>
                <div class="footer__cell--left-text">
                    沪ICP证 沪B2-20160111 | 沪网文（2016）0033-033号 | <a class="footer-Records-Link" href="https://beian.miit.gov.cn/" >沪ICP备15039130号</a>
                    <br>
                    沪公网安备 31010702004061号
                    <br>
                    出版物经营许可证号：新出发沪批字第Y7061号
                </div>
                <div class="footer__copyright">
                    © {{this.year}} Gamepoch Inc. All rights reserved.
                </div>
            </div>
        </div>

        <div v-if="this.$store.state.language == 'en'" class="footer footer--desktop no-select desktop">
            <div class="footer__inner">
                <div class="footer__cell footer__cell--left">
                    <div class="footer__cell--left-text">
                        沪ICP证 沪B2-20160111 | 沪网文（2016）0033-033号 | <a class="footer-Records-Link" href="https://beian.miit.gov.cn/" >沪ICP备15039130号</a>
                        <br>
                        沪公网安备 31010702004061号
                        <br>
                        出版物经营许可证号：新出发沪批字第Y7061号
                    </div>
                </div>
                <a href="" class="site__footer--logo"></a>
                <div class="footer__cell footer__cell--right">
                    <div class="footer__social-desktop">
                        <span>
                        <span class="footer__connect">CONNECT</span>
                        </span>
                        <span class="footer__spacer">|</span>
                        <!-- facebook -->
                        <a href="https://www.facebook.com/profile.php?id=100011243130897" target="_blank" v-show="true">
                        <div class="footer__icon footer__icon--facebook"></div>
                        </a>
                        <!-- twitter -->
                        <a href="https://twitter.com/gamepochsh" target="_blank" v-show="true">
                        <div class="footer__icon footer__icon--twitter"></div>
                        </a>
                        <!-- wechat -->
                        <a target="_blank" class="gp-qrcode-wrap">
                        <div class="footer__icon footer__icon--youtube"></div>
                        </a>
                        <!-- weibo -->
                        <a href="https://weibo.com/gamepoch" target="_blank">
                        <div class="footer__icon footer__icon--twitch"></div>
                        </a>
                        <!-- ins -->
                        <a href="https://www.instagram.com/gamepoch_cn/" target="_blank" v-show="true">
                        <div class="footer__icon footer__icon--instagram"></div>
                        </a>
                    </div>
                    <div class="footer__copyright">
                        © {{this.year}} Gamepoch Inc. All rights reserved.
                    </div>
                </div>
        </div>
        </div>
        <!--------------------------->


        <div class="gp-qrcode-container"><img src="../assets/wxQrCode.jpg" alt="" class="gp-qrcode-desktop"></div>
    </footer>

    



</template>

<style lang="scss" scoped>
.footer-Records-Link{
    text-decoration:underline;
}
.footer {
    font-family: Roboto Condensed,sans-serif;
    font-weight: 300;
    position: relative;
    display: inline-block;
    width: 100%;
    background: linear-gradient(#000,#1d1d1b);
    color: #878787;
}
.footer--desktop .site__footer--logo{
    position: absolute;
    display: inline-block;
    transform: translateX(-50%);
    bottom: 23px;
    left: 50%;
    background-image: url(../assets/home/gamepoch-logo_2.png);
    background-position: 0 0;
    background-size: 100% auto;
    width: 170px;
    height: 45px;
}
.footer--desktop .footer__cell--left-text{
    text-align: left;
    line-height: 18px;
    color: #707070;
    font-size: 11px;
    width: 400px;
}

.footer--mobile .site__footer--logo{
    display: block;
    margin: 25px auto 0;
    background-image: url(../assets/home/gamepoch-logo_2.png);
    background-position: 0 0;
    background-size: 100% auto;
    width: 170px;
    height: 45px;
}

.footer--mobile .footer__cell--left-text{
    text-align: center;
    line-height: 18px;
    color: #707070;
    font-size: 11px;
    width: 100%;
}





.footer__inner {
    width: 100%;
    display: inline-block;
    text-align: center !important;
}
.footer__logo-desktop, .footer__logo-mobile {
    background-image: url(../assets/sprite-ui.png);
    background-size: 302.5px 276.5px;
    height: 28px;
}
.footer__logo-mobile {
    background-position: -82.5px -100px;
    width: 43px;
    margin: 18px auto 0;
}
/* 
*/
.footer__social-mobile {
    margin: 2em auto;
    a{
        margin: 0 2%;
    }
    .footer__icon-mobile.footer__icon-mobile--facebook {
        background-image: url(../assets/sprite-ui.png);
        background-position: -33px -157px;
        background-size: 302.5px 276.5px;
        width: 28px;
        height: 29.5px;
    }
    .footer__icon-mobile.footer__icon-mobile--twitter {
        background-image: url(../assets/sprite-ui.png);
        background-position: 0 -157px;
        background-size: 302.5px 276.5px;
        width: 28px;
        height: 29.5px;
    }
    .footer__icon-mobile.footer__icon-mobile--youtube {
        background-image: url(../assets/sprite-ui.png);
        background-position: -164.5px -103px;
        background-size: 302.5px 276.5px;
        width: 30px;
        height: 30px;
    }
    .footer__icon-mobile.footer__icon-mobile--twitch {
        background-image: url(../assets/sprite-ui.png);
        background-position: -164.5px -33px;
        background-size: 302.5px 276.5px;
        width: 30px;
        height: 30px;
    }
    .footer__icon-mobile.footer__icon-mobile--instagram {
        background-image: url(../assets/sprite-ui.png);
        background-position: -164.5px -68px;
        background-size: 302.5px 276.5px;
        width: 30px;
        height: 30px;
    }
}
.footer__icon-mobile {
    display: inline-block;
    vertical-align: top;
}

.footer__icon {
    display: inline-block;
    margin: 0 2px;
}
.footer__links{
    font-family: Roboto Condensed,sans-serif;
    font-weight: 700;
    letter-spacing: .2px;
    color: #565655;
    padding-left: 48px;
    font-size: 1.05em;
}
.footer__links>a:hover {
    color: red;
}
.footer__links>a {
    display: inline-block;
    color: inherit;
}
.link__spacer {
    margin: 0 2px;
}
.footer__copyright{
    color: #545453;
    font-size: .8em;
}
@media (min-width: 0em) and (max-width: 800px){
    .footer__copyright {
        margin: 2em;
    }
}
.footer--desktop .footer__inner {
    display: table;
    width: 100%;
    vertical-align: bottom;
    padding: 23px 18px;
}
.footer__cell {
    display: table-cell;
    width: 50%;
    vertical-align: bottom;
}
.footer__cell--left {
    position: relative;
    .footer__logo-desktop {
        background-position: -164.5px 0;
        width: 42px;
        position: absolute;
        bottom: 0;
        left: 0;
        display: inline-block;
    }
}
.footer__cell--right {
    text-align: right;
    .footer__social-desktop {
        color: #6f6f6e;
        font-size: .8em;
        margin: 10px 0;
    }
    .footer__social-desktop>* {
        vertical-align: middle;
        display: inline-block;
    }
    .footer__connect {
        font-family: Roboto Condensed,sans-serif;
        font-weight: 700;
        letter-spacing: .7px;
        font-size: 1.2em;
        color: #545453;
    }
    .footer__spacer {
        color: #757574;
        transform: scaleY(1.3);
        margin: 0 8px;
    }
    .footer__social-desktop a {
        font-size: 0;
    }
    .footer__icon.footer__icon--facebook {
        background-image: url(../assets/sprite-ui.png);
        background-position: -125px -218.5px;
        background-size: 302.5px 276.5px;
        width: 19px;
        height: 20px
    }

    @media (min-width: 1920px) {
        .footer__icon.footer__icon--facebook {
            background-image:url(../assets/sprite-lfd.png);
            background-position: -211px -28px;
            background-size: 251.5px 233.5px;
            width: 25px;
            height: 25px
        }
    }

    .footer__icon.footer__icon--twitch {
        background-image: url(../assets/sprite-ui.png);
        background-position: -76px -218.5px;
        background-size: 302.5px 276.5px;
        width: 20px;
        height: 20px
    }

    @media (min-width: 1920px) {
        .footer__icon.footer__icon--twitch {
            background-image:url(../assets/sprite-lfd.png);
            background-position: -174.5px -159.5px;
            background-size: 251.5px 233.5px;
            width: 25px;
            height: 25px
        }
    }

    .footer__icon.footer__icon--twitter {
        background-image: url(../assets/sprite-ui.png);
        background-position: -101px -218.5px;
        background-size: 302.5px 276.5px;
        width: 19px;
        height: 20px
    }

    @media (min-width: 1920px) {
        .footer__icon.footer__icon--twitter {
            background-image:url(../assets/sprite-lfd.png);
            background-position: -144.5px -159.5px;
            background-size: 251.5px 233.5px;
            width: 25px;
            height: 25px
        }
    }

    .footer__icon.footer__icon--youtube {
        background-image: url(../assets/sprite-ui.png);
        background-position: -130.5px -100px;
        background-size: 302.5px 276.5px;
        width: 20px;
        height: 20px
    }

    @media (min-width: 1920px) {
        .footer__icon.footer__icon--youtube {
            background-image:url(../assets/sprite-lfd.png);
            background-position: -114.5px -159.5px;
            background-size: 251.5px 233.5px;
            width: 25px;
            height: 25px
        }
    }

    .footer__icon.footer__icon--instagram {
        background-image: url(../assets/sprite-ui.png);
        background-position: -180px -157px;
        background-size: 302.5px 276.5px;
        width: 20px;
        height: 20px
    }

    @media (min-width: 1920px) {
        .footer__icon.footer__icon--instagram {
            background-image:url(../assets/sprite-lfd.png);
            background-position: -211px 0;
            background-size: 251.5px 233.5px;
            width: 25px;
            height: 25px
        }
    }
}
.gp-footer{
    position: relative;
}
.gp-qrcode-container{
    display: none;
    position: absolute;
    bottom: 90px;
    right: 50px;
    z-index: 999;
}
.gp-qrcode-mobile{
    margin-top: 2em;
    width: 100px;
    height: 100px;
}
.gp-qrcode-desktop{
    width: 100px;
    height: 100px;
}

</style>


<script>

export default {
  name: "gp-footer",
  data() {
    return {
        year:"2023"
    };
  },
  components: {},
  mounted(){

    this.year=new Date().getFullYear();
    $(".gp-qrcode-wrap").hover(function(){
        $(".gp-qrcode-container").fadeIn();
    },function(){
        $(".gp-qrcode-container").fadeOut();
    });
  },
  methods: {
  },
};
</script>


// WEBPACK FOOTER //
// src/components/gp-footer.vue